export const ALLOCATION_TABS = [
  { id: "new", label: "Новое распределение" },
  { id: "history", label: "История распределений" },
];

export const ALLOCATION_STEPS = [
  { id: "operations", label: "Операции" },
  { id: "recipients", label: "Получатели" },
  { id: "base", label: "База" },
  { id: "review", label: "Проверка" },
  { id: "result", label: "Результат" },
];

/** Распределяются только управленческие данные — слой на странице не переключается */
export const ALLOCATION_DATA_LAYER = "management";

/** Перезапуск и удаление меняют только проводки своей записи реестра */
export const ONLY_THIS_RECORD_NOTE =
  "Проводки других распределений за тот же период останутся без изменений.";

export const JOURNAL_PATH = "/finances/accounting-planning/operations-journal";
